import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PointDto } from 'src/app/models/fds2-points/fds2-points.model';
import { ApiService } from 'src/app/services/api.service';
import { debounceTime, Subject } from 'rxjs';
import { AbstractControl } from '@angular/forms';
import { FormFieldErrorMessagesComponent } from '../form-field-error-messages/form-field-error-messages.component';

@Component({
  selector: 'app-form-point-input-field',
  standalone: true,
  imports: [CommonModule, FormFieldErrorMessagesComponent],
  templateUrl: './form-point-input-field.component.html',
  styleUrls: ['./form-point-input-field.component.scss'],
})
export class FormPointInputFieldComponent {
  @Input() formField: AbstractControl | null = null;
  @ViewChild('customInput', { static: false }) customInput!: ElementRef;
  items: PointDto[] = [];
  page = 0;
  isLoading = false;
  allItemsLoaded = false;
  searchKey = '';
  searchSubject: Subject<string> = new Subject<string>();
  isDropdownVisible = false;
  isElementFocused = false;
  @Output() selectedPoint = new EventEmitter<PointDto>();
  localSelectedPoint: PointDto | undefined;

  constructor(private cdr: ChangeDetectorRef, private apiService: ApiService) {
    // Debounce do obsługi wyszukiwania
    this.searchSubject.pipe(debounceTime(500)).subscribe((searchKey) => {
      this.searchKey = searchKey ?? '';
      if (this.searchKey.length >= 1) {
        this.items = [];
        this.page = 0;
        this.allItemsLoaded = false;
        this.isLoading = false;
        this.loadItems();
      } else if (this.searchKey.length === 0) {
        this.items = [];
        this.page = 0;
        this.allItemsLoaded = false;
        this.isLoading = false;
      }
    });
  }

  // Obsługa zmiany wartości inputa
  onInputChange(value: string): void {
    this.searchSubject.next(value ?? '');
    this.isDropdownVisible = value.length >= 1;
  }

  // Ładowanie wyników
  async loadItems(): Promise<void> {
    if (this.isLoading || this.allItemsLoaded) return;

    this.isLoading = true;
    this.cdr.detectChanges();
    try {
      const newItems =
        (await this.apiService
          .getPoints(this.searchKey, this.page)
          .toPromise()) ?? [];
      if (newItems.length === 0) {
        this.allItemsLoaded = true;
      } else {
        this.items = [...this.items, ...newItems];
      }
    } catch (error) {
      console.error('Error loading items:', error);
    } finally {
      this.page++;
      this.isLoading = false;
      this.cdr.detectChanges();
    }
  }

  // Obsługa przewijania listy
  onScroll(event: any): void {
    const element = event.target;
    if (element.scrollTop + element.clientHeight >= element.scrollHeight - 10) {
      this.loadItems();
    }
  }

  // Obsługa focus i blur
  onInputFocus(isFocused: boolean): void {
    this.isElementFocused = isFocused;
    if (!isFocused) {
      this.formField?.setValue(this.localSelectedPoint?.pointName);
    }
  }

  // Obsługa wybrania punktu
  public onItemClick(pointDto: PointDto | undefined): void {
    this.localSelectedPoint = pointDto;
    this.selectedPoint.emit(pointDto);
  }

  isControlTouchedAndInvalid(control: AbstractControl | null) {
    return control?.invalid && control?.touched;
  }
}
